var MetadataModules;
(function (MetadataModules) {
    MetadataModules["CALIBRATION"] = "calibrationModule";
    MetadataModules["CINE"] = "cineModule";
    MetadataModules["FRAME_OF_REFERENCE"] = "frameOfReferenceModule";
    MetadataModules["GENERAL_IMAGE"] = "generalImageModule";
    MetadataModules["GENERAL_SERIES"] = "generalSeriesModule";
    MetadataModules["GENERAL_STUDY"] = "generalStudyModule";
    MetadataModules["IMAGE_PIXEL"] = "imagePixelModule";
    MetadataModules["IMAGE_PLANE"] = "imagePlaneModule";
    MetadataModules["IMAGE_URL"] = "imageUrlModule";
    MetadataModules["MODALITY_LUT"] = "modalityLutModule";
    MetadataModules["MULTIFRAME"] = "multiframeModule";
    MetadataModules["NM_MULTIFRAME_GEOMETRY"] = "nmMultiframeGeometryModule";
    MetadataModules["OVERLAY_PLANE"] = "overlayPlaneModule";
    MetadataModules["PATIENT"] = "patientModule";
    MetadataModules["PATIENT_DEMOGRAPHIC"] = "patientDemographicModule";
    MetadataModules["PATIENT_STUDY"] = "patientStudyModule";
    MetadataModules["PET_IMAGE"] = "petImageModule";
    MetadataModules["PET_ISOTOPE"] = "petIsotopeModule";
    MetadataModules["PET_SERIES"] = "petSeriesModule";
    MetadataModules["SCALING"] = "scalingModule";
    MetadataModules["SOP_COMMON"] = "sopCommonModule";
    MetadataModules["ULTRASOUND_ENHANCED_REGION"] = "ultrasoundEnhancedRegionModule";
    MetadataModules["ECG"] = "ecgModule";
    MetadataModules["VOI_LUT"] = "voiLutModule";
    MetadataModules["TRANSFER_SYNTAX"] = "transferSyntax";
    MetadataModules["PLANE_ORIENTATION"] = "PlaneOrientation";
    MetadataModules["PLANE_POSITION"] = "PlanePosition";
    MetadataModules["PIXEL_MEASURES"] = "PixelMeasures";
    MetadataModules["XRAY_GEOMETRY"] = "XrayGeometry";
    MetadataModules["FRAME_PIXEL_DATA"] = "FramePixelData";
    MetadataModules["FRAME_MODULE"] = "frameModule";
    MetadataModules["URI_MODULE"] = "uriModule";
    MetadataModules["WADO_WEB_CLIENT"] = "wadoWebClient";
    MetadataModules["INSTANCE"] = "instance";
    MetadataModules["IMAGE_SOP_INSTANCE_REFERENCE"] = "ImageSopInstanceReference";
    MetadataModules["REFERENCED_SERIES_REFERENCE"] = "ReferencedSeriesReference";
    MetadataModules["PREDECESSOR_SEQUENCE"] = "PredecessorSequence";
    MetadataModules["STUDY_DATA"] = "StudyData";
    MetadataModules["SERIES_DATA"] = "SeriesData";
    MetadataModules["IMAGE_DATA"] = "ImageData";
    MetadataModules["RTSS_INSTANCE_DATA"] = "RtssInstanceData";
    MetadataModules["NEW_INSTANCE_DATA"] = "NewInstanceData";
    MetadataModules["RTSS_CONTOUR"] = "metaRTSSContour";
    MetadataModules["SEG_BIT"] = "metaSegBitmap";
    MetadataModules["SR_ANNOTATION"] = "metaSrAnnotation";
    MetadataModules["COMPRESSED_FRAME_DATA"] = "compressedFrameData";
    MetadataModules["BASE_IMAGE_ID"] = "baseImageId";
    MetadataModules["FRAME_IMAGE_IDS"] = "frameImageIds";
    MetadataModules["NATURALIZED"] = "naturalized";
})(MetadataModules || (MetadataModules = {}));
export const ADD_MODULE_TYPE_SUFFIX = 'Add';
export function getAddModuleType(type) {
    return `${type}${ADD_MODULE_TYPE_SUFFIX}`;
}
export default MetadataModules;
